import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import { test } from '@/modules/limits'

export const testPhraseValidationMixin = {
  mixin: [validationMixin],

  computed: {
    errors () {
      if (!this.$v.localPhrase.required) {
        return this.$t('validations.test-phrase-validation.phrase.required')
      }

      if (!this.$v.localPhrase.maxLength) {
        return this.$t('validations.test-phrase-validation.phrase.maxLength', { maxLength: 500 })
      }
    }
  },

  validations: {
    localPhrase: {
      required,
      maxLength: maxLength(test.phraseMaxLength)
    }
  }
}
